import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import * as _ from 'lodash';
import { Resolve, ActivatedRouteSnapshot, Router, ActivatedRoute } from '@angular/router';
import { NewsService } from '../rest/api/news.service';
import * as moment from 'moment';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'app-news-list',
  templateUrl: './news-list.component.html',
  styleUrls: ['./news-list.component.scss']
})
export class NewsListComponent implements OnInit {
  languageData: any;
  newsList: any;
  lang: any;
  totalCount: number;
  itemsPerPage = 9;
  currentPage = 1;
  pageLoader = true;

  constructor(
    private route: ActivatedRoute,
    public newsService: NewsService,
    public translateService: TranslateService,
  ) { }

  ngOnInit() {
    this.lang = this.translateService.currentLang ? this.translateService.currentLang :
    (localStorage.getItem('language') ? localStorage.getItem('language') : '');
    this.getAllNewsList(1, this.itemsPerPage);
    this.languageData = this.route.snapshot.data.language;
  }

  getAllNewsList(page, limit) {
    const thisobject = this;
    this.newsService.getNewsList({
      page: page,
      paginate: limit,
      lang: this.lang
    }).subscribe((response: any) => {
      thisobject.pageLoader = false;
      this.newsList = response.data;
      this.newsList = _.orderBy(this.newsList, ['published_at'], ['desc']);
      this.totalCount = response.meta && response.meta.pagination && response.meta.pagination.total ? response.meta.pagination.total : 0;
    }, err => {
      thisobject.pageLoader = false;
      this.newsList = [];
      console.log(err && err.error);
    });
  }

  pageChanged(event) {
    this.pageLoader = true;
    this.currentPage = event;
    this.getAllNewsList(event, this.itemsPerPage);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  getMonth(data) {
    const check = moment(data.published_at, 'YYYY/MM/DD');
    const month = check.format('MMM');
    return month;
  }

  getDate(data) {
    const check = moment(data.published_at, 'YYYY/MM/DD');
    const day   = check.format('D');
    return day;
  }

}
